function between (min, max) {
  return function (number) {
    return number >= min && number <= max
  }
}

export default between
